export class TemplateApp {

    dropdown_stop() {
        try {
            let dropdownMenus = document.querySelectorAll('.dropdown-menu.stop');
            dropdownMenus.forEach(function (dropdownMenu) {
                dropdownMenu.addEventListener('click', function (event) {
                    event.stopPropagation();
                });
            });
        } catch (err) {
        }
    }

    icon_create() {
        try {
            lucide.createIcons();
        } catch (err) {
        }
    }

    top_bar_dark_light() {
        try {
            let themeColorToggle = document.getElementById('light-dark-mode');
            if (themeColorToggle) {
                themeColorToggle.addEventListener('click', function (e) {
                    let currentTheme = document.documentElement.getAttribute('data-bs-theme');
                    if (currentTheme === 'light') {
                        document.documentElement.setAttribute('data-bs-theme', 'dark');
                    } else {
                        document.documentElement.setAttribute('data-bs-theme', 'light');
                    }
                });
            }
        } catch (err) {
        }
    }

    collapsed() {
        try {
            let collapsedToggle = document.querySelector(".mobile-menu-btn");
            const sidebarOverlay = document.querySelector('.startbar-overlay');
            collapsedToggle?.addEventListener('click', function () {
                let sidebarSize = document.body.getAttribute("data-sidebar-size");
                if (sidebarSize === "collapsed") {
                    document.body.setAttribute("data-sidebar-size", "default")
                } else {
                    document.body.setAttribute("data-sidebar-size", "collapsed")
                }
            });
            if (sidebarOverlay) {
                sidebarOverlay.addEventListener('click', () => {
                    document.body.setAttribute("data-sidebar-size", "collapsed")
                })
            }
            this.changeSidebarSize = () => {
                if (window.innerWidth >= 310 && window.innerWidth <= 1440) {
                    document.body.setAttribute("data-sidebar-size", "collapsed")
                } else {
                    document.body.setAttribute("data-sidebar-size", "default")
                }
            }
            window.addEventListener('resize', () => {
                this.changeSidebarSize()
            })
            this.changeSidebarSize();
        } catch (err) {}
    }

    tooltip_popover(){
        try {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
            let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
            let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
                return new bootstrap.Popover(popoverTriggerEl)
            });
        } catch (err) {
        }
    }

    change_sidebar_size(){
        try {
            this.changeSidebarSize();
            window.addEventListener('resize', this.changeSidebarSize);
            window.addEventListener('resize', () => {this.changeSidebarSize()})
            this.changeSidebarSize();
        } catch (err) {
        }
    }

    windowScroll() {
        const navbar = document.getElementById("topbar-custom");
        if (navbar != null) {
            if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
            ) {
                navbar.classList.add("nav-sticky");
            } else {
                navbar.classList.remove("nav-sticky");
            }
        }
    }

    menu_sticky() {
        window.addEventListener('scroll', (ev) => {
            ev.preventDefault();
            this.windowScroll();
        })
    }

    updateSidebarActiveLink = (currentPath) => {
        if (!currentPath) {
            currentPath = window.location.pathname;
            if (currentPath.length > 1) {
                currentPath = currentPath.replace(/\/$/, '');
            }
        }

        const sidebarLinks = document.querySelectorAll('.startbar-menu .nav-link');

        sidebarLinks.forEach(link => {
            link.classList.remove('active');
            link.closest('.nav-item')?.classList.remove('active');
        });

        sidebarLinks.forEach(link => {
            const href = link.getAttribute('href');

            if (!href || href.startsWith('#')) {
                return;
            }

            const linkPath = new URL(link.href).pathname;

            if (linkPath === currentPath) {
                link.classList.add('active');
                link.closest('.nav-item')?.classList.add('active');

                const parentCollapse = link.closest('.collapse');
                if (parentCollapse) {
                    const parentTriggerLink = document.querySelector(`a[href="#${parentCollapse.id}"]`);
                    if (parentTriggerLink) {
                        parentTriggerLink.setAttribute('aria-expanded', 'true');
                        parentCollapse.classList.add('show');
                        parentTriggerLink.closest('.nav-item')?.classList.add('active');
                    }
                }
            }
        });
    }

    imageDragPrevent = () => {
        document.addEventListener('dragstart', function(event) {
            if (event.target.tagName.toUpperCase() === 'IMG') {
                event.preventDefault();
            }
        });
    }

    templateInit(){
        this.dropdown_stop();
        this.icon_create();
        this.top_bar_dark_light();
        this.collapsed();
        this.tooltip_popover();
        this.change_sidebar_size();
        this.menu_sticky();
        this.imageDragPrevent();
    }

}
